import apiClient from "../../../lib/api_client"

export const UserLogin = async (payload) => {
  try {
    const response = await apiClient.post(`/login`, payload, {
      headers: {
        ProjectDetail: "SelectWeb",
      },
    })

    if (response?.status === 200) {
      return response.data
    } else {
      console.warn("Login failed:", response?.statusText || "Unknown error")
      return null
    }
  } catch (error) {
    console.error("Error logging in:", error?.response?.data || error.message)
    throw error
  }
}
